import { AppContainer } from '../markets/app.container';
import { createRoot } from 'react-dom/client';
import { appRoot, setAppRoot } from 'index';
import { CacheProvider, EmotionCache } from '@emotion/react';
import createCache from '@emotion/cache';
import { ThemeEnum } from 'types/market-types';

export let shadowContainer: ShadowRoot | null = null;
export const setShadowContainer = (newContainer: ShadowRoot | null): void => {
  shadowContainer = newContainer;
};
export const shadowRootElement = document.createElement('div');
let cache: EmotionCache | null = null;
const emotionRoot = document.createElement('style');
const swiperLinkElement = document.createElement('link');
swiperLinkElement.setAttribute('rel', 'stylesheet');
swiperLinkElement.setAttribute('href', 'https://unpkg.com/swiper@6.8.4/swiper.min.css');

const containerName = 'tis-element-container';

export const renderDom = (
  appSelector: string,
  container: Element | null,
  configuration: TimApp.MarketConfiguration,
  isInit: boolean,
  theme?: ThemeEnum | null
): void => {
  if (!container) {
    return;
  }
  if (!shadowContainer && !isInit) {
    shadowRootElement.id = containerName;
    shadowRootElement.classList.add(containerName);
    const inBody = configuration?.inBody;
    if (configuration) {
      if (inBody) {
        shadowRootElement?.classList.add('insurance-container-in-body');
      } else {
        shadowRootElement.classList.add('insurance-container-width');
      }
      if (theme) {
        shadowRootElement.classList.add(`insurance-container-${theme}`);
      }
    }
    shadowContainer = container.attachShadow({
      mode: 'open',
    });
    shadowContainer.append(emotionRoot);
    shadowContainer.append(shadowRootElement);
    shadowContainer.append(swiperLinkElement);

    if (!cache) {
      cache = createCache({
        key: 'css',
        prepend: true,
        container: emotionRoot,
        speedy: false,
      });
    }
  }

  if (!shadowContainer) shadowContainer = container?.shadowRoot;

  if (!appRoot) {
    setAppRoot(createRoot(shadowRootElement));
  }

  if (cache)
    appRoot?.render(
      <CacheProvider value={cache}>
        <AppContainer appSelector={appSelector} marketConfiguration={configuration} theme={theme} />
      </CacheProvider>
    );
};
export class EventManager {
  private isInit = false;

  public theme: ThemeEnum | null = null;

  public appSelector = '';

  public appSelector$: HTMLElement | null = null;

  public configuration: TimApp.MarketConfiguration | null = null;

  public inBody = false;

  public setIsInit = (_isInit: boolean): void => {
    this.isInit = _isInit;
  };

  public getIsInit = (): boolean => this.isInit;

  destroyCalculator(): void {
    shadowContainer = null;
    cache = null;
    this.isInit = false;
    this.theme = ThemeEnum.default;
  }

  subscribeBeforeInit(selector = window): boolean {
    if (selector) {
      this.onInitListened = this.onInitListened.bind(this);
      if (this.configuration) {
        this.onInitListened();
      }
      return true;
    }
    return false;
  }

  onInitListened(): boolean {
    if (process.env.NODE_ENV !== 'test') {
      const errorLabel = 'Configuration error:';
      if (
        this.appSelector$ &&
        this.configuration &&
        typeof this.configuration === 'object' &&
        Object.keys(this.configuration).length > 0
      ) {
        try {
          if (this.configuration) {
            this.configuration.inBody = this.inBody;
          }
          renderDom(this.appSelector, this.appSelector$, this.configuration, this.isInit, this.theme);
          this.isInit = true;
        } catch (error_) {
          console.error(errorLabel, error_);
        }
        return true;
      }
      const error = new Error('Configuration element not found.');
      console.error(errorLabel, error);
      return false;
    }
    return true;
  }

  init(): boolean {
    this.subscribeBeforeInit();
    return true;
  }
}
